module.exports = __webpack_public_path__ + "img/196.b68c3dd8.jpg";